/* CharmCraft brand scripts: Judge.me sync, Wishlist (header + cards + PDP + modal + page), Email cleanup, and Sticky ATC total. */
(function () {
  function syncJudgeMeSettings() {
    if (!window.jdgmSettings) return;
    Object.assign(window.jdgmSettings, {
      widget_primary_color: '#FF8A1E',
      widget_secondary_color: '#FFF3E3',
      widget_star_use_custom_color: true,
      widget_write_review_use_custom_color: true,
      widget_write_review_bg_color: '#FF8A1E',
      widget_write_review_text_color: '#2A2118',
      widget_histogram_use_custom_color: true,
      widget_pagination_use_custom_color: true,
      widget_verified_badge_use_custom_color: true,
      verified_badge_bg_color: '#FF8A1E',
      verified_badge_text_color: '#2A2118',
      review_widget_button_text_color: '#2A2118',
      review_widget_text_color: '#2A2118',
      review_widget_lighter_text_color: '#5C4F42',
      review_form_star_color: '#FF8A1E',
      review_form_button_color: '#FF8A1E',
      review_form_button_text_color: '#2A2118',
      review_form_text_color: '#2A2118',
      review_form_corner_style: 'round',
      hide_badge_preview_if_no_reviews: false
    });
  }

  function sanitizePersonalEmail() {
    const oldEmail = 'nguyenducviet.lsb@gmail.com';
    const newEmail = 'support@getcharmcraft.com';
    document.querySelectorAll('a[href*="' + oldEmail + '"]').forEach((a) => {
      a.href = 'mailto:' + newEmail;
      if (a.textContent.includes(oldEmail)) {
        a.textContent = a.textContent.replaceAll(oldEmail, newEmail);
      }
    });
    document.querySelectorAll('.shopify-policy__body li, .shopify-policy__body p, main p, main li').forEach((el) => {
      if (el.innerHTML.includes(oldEmail)) {
        el.innerHTML = el.innerHTML.replaceAll(oldEmail, newEmail);
      }
      if (el.innerHTML.includes('mailto:' + newEmail + '">' + newEmail + '</a> / <a href="mailto:' + newEmail)) {
        el.innerHTML = el.innerHTML.replaceAll(
          '<a href="mailto:' + newEmail + '">' + newEmail + '</a> / <a href="mailto:' + newEmail + '">' + newEmail + '</a>',
          '<a href="mailto:' + newEmail + '">' + newEmail + '</a>'
        );
      }
      if (el.innerHTML.includes('mailto:' + newEmail + '">' + newEmail + '</a> or <a href="mailto:' + newEmail)) {
        el.innerHTML = el.innerHTML.replaceAll(
          '<a href="mailto:' + newEmail + '">' + newEmail + '</a> or <a href="mailto:' + newEmail + '">' + newEmail + '</a>',
          '<a href="mailto:' + newEmail + '">' + newEmail + '</a>'
        );
      }
    });
  }

  syncJudgeMeSettings();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      syncJudgeMeSettings();
      sanitizePersonalEmail();
    });
  } else {
    sanitizePersonalEmail();
  }

  document.addEventListener('click', (e) => {
    const badge = e.target.closest('a.cc-review-badge');
    if (!badge) return;
    const target = document.getElementById('cc-reviews');
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
})();

/* ---------- Wishlist Manager (Card Icons, Header Icon, Single PDP Button, Drawer & Page) ---------- */
(function () {
  const STORAGE_KEY = 'cc_wishlist_items_v1';

  function getItems() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function saveItems(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {}
  }

  function hasItem(productId) {
    const idStr = String(productId);
    return getItems().some((item) => String(item.id) === idStr);
  }

  function toggleItem(itemData) {
    const items = getItems();
    const idStr = String(itemData.id);
    const idx = items.findIndex((i) => String(i.id) === idStr);
    let added = false;
    if (idx >= 0) {
      items.splice(idx, 1);
    } else {
      items.unshift(itemData);
      added = true;
    }
    saveItems(items);
    syncWishlistUI();
    return added;
  }

  function ensureSinglePdpWishlistButton() {
    const container = document.getElementById('wishlist-hero-product-page-button');
    if (!container) return;

    /* Remove any extra children injected by Wishlist Hero so only 1 button ever exists */
    Array.from(container.children).forEach((child) => {
      if (!child.classList.contains('cc-pdp-wishlist-fallback')) {
        child.remove();
      }
    });

    const existing = container.querySelectorAll('.cc-pdp-wishlist-fallback');
    if (existing.length > 1) {
      existing.forEach((el, idx) => {
        if (idx > 0) el.remove();
      });
    }
    if (existing.length >= 1) return;

    const productTitle = document.querySelector('.product-details h1')?.textContent?.trim() || document.title;
    const productImg = document.querySelector('.product-media-container img, .product-information img')?.src || '';
    const productPrice = document.querySelector('.product-details .price')?.textContent?.trim() || '';
    const productId = container.dataset.wlhId || window.ShopifyAnalytics?.meta?.product?.id || window.location.pathname;

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cc-pdp-wishlist-fallback';
    btn.setAttribute('data-cc-pdp-wishlist', 'true');
    btn.dataset.productId = String(productId);
    btn.dataset.productTitle = productTitle;
    btn.dataset.productUrl = window.location.href;
    btn.dataset.productImage = productImg;
    btn.dataset.productPrice = productPrice;
    btn.innerHTML =
      '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
      '<span>Add to wishlist</span>';
    container.appendChild(btn);
  }

  function renderModalItems() {
    const lists = document.querySelectorAll('[data-cc-wishlist-list]');
    if (!lists.length) return;
    const items = getItems();
    const html =
      items.length === 0
        ? '<p style="margin:12px 0;text-align:center;color:#5c4f42;">Your wishlist is empty. Tap the heart icon on any product to save it here!</p>'
        : items
            .map(
              (item) =>
                '<div class="cc-wishlist-item">' +
                (item.image ? '<img class="cc-wishlist-item__img" src="' + item.image + '" alt="">' : '<div class="cc-wishlist-item__img"></div>') +
                '  <div>' +
                '    <a class="cc-wishlist-item__title" href="' + (item.url || '#') + '">' + (item.title || 'Product') + '</a>' +
                (item.price ? '<div class="cc-wishlist-item__price">$' + String(item.price).replace(/^\$/, '') + '</div>' : '') +
                '  </div>' +
                '  <div class="cc-wishlist-item__actions">' +
                '    <a class="cc-wishlist-item__view" href="' + (item.url || '#') + '">View</a>' +
                '    <button type="button" class="cc-wishlist-item__remove" data-cc-wishlist-remove="' + item.id + '" aria-label="Remove">×</button>' +
                '  </div>' +
                '</div>'
            )
            .join('');
    lists.forEach((list) => {
      list.innerHTML = html;
    });
  }

  function syncWishlistUI() {
    ensureSinglePdpWishlistButton();
    const items = getItems();
    const count = items.length;

    document.querySelectorAll('[data-cc-wishlist-count]').forEach((badge) => {
      badge.textContent = String(count);
      badge.hidden = count === 0;
    });

    document.querySelectorAll('[data-cc-wishlist-trigger]').forEach((trigger) => {
      trigger.classList.toggle('has-items', count > 0);
    });

    document.querySelectorAll('[data-cc-wishlist-btn]').forEach((btn) => {
      const pid = btn.dataset.productId;
      const active = pid && hasItem(pid);
      btn.classList.toggle('is-wishlisted', Boolean(active));
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    document.querySelectorAll('[data-cc-pdp-wishlist]').forEach((btn) => {
      const pid = btn.dataset.productId;
      const active = pid && hasItem(pid);
      const svg = btn.querySelector('svg');
      const span = btn.querySelector('span');
      if (svg) svg.setAttribute('fill', active ? '#2A2118' : 'none');
      if (span) span.textContent = active ? 'Added to wishlist' : 'Add to wishlist';
    });

    renderModalItems();
  }

  function openWishlistModal() {
    let modal = document.getElementById('cc-wishlist-modal');
    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'cc-wishlist-modal';
      modal.className = 'cc-wishlist-modal';
      modal.innerHTML =
        '<div class="cc-wishlist-modal__dialog" role="dialog" aria-modal="true" aria-label="My Wishlist">' +
        '  <div class="cc-wishlist-modal__header">' +
        '    <h2 class="cc-wishlist-modal__title">My Wishlist</h2>' +
        '    <button type="button" class="cc-wishlist-modal__close" data-cc-wishlist-close aria-label="Close">×</button>' +
        '  </div>' +
        '  <div class="cc-wishlist-modal__body" data-cc-wishlist-list></div>' +
        '</div>';
      document.body.appendChild(modal);
    }
    renderModalItems();
    modal.hidden = false;
  }

  document.addEventListener('click', (e) => {
    const cardBtn = e.target.closest('[data-cc-wishlist-btn]');
    if (cardBtn) {
      e.preventDefault();
      e.stopPropagation();
      toggleItem({
        id: cardBtn.dataset.productId,
        variantId: cardBtn.dataset.variantId,
        title: cardBtn.dataset.productTitle,
        url: cardBtn.dataset.productUrl,
        image: cardBtn.dataset.productImage,
        price: cardBtn.dataset.productPrice
      });
      return;
    }

    const pdpBtn = e.target.closest('[data-cc-pdp-wishlist]');
    if (pdpBtn) {
      e.preventDefault();
      toggleItem({
        id: pdpBtn.dataset.productId,
        title: pdpBtn.dataset.productTitle,
        url: pdpBtn.dataset.productUrl,
        image: pdpBtn.dataset.productImage,
        price: pdpBtn.dataset.productPrice
      });
      return;
    }

    const trigger = e.target.closest('[data-cc-wishlist-trigger]');
    if (trigger) {
      e.preventDefault();
      openWishlistModal();
      return;
    }

    const removeBtn = e.target.closest('[data-cc-wishlist-remove]');
    if (removeBtn) {
      e.preventDefault();
      toggleItem({ id: removeBtn.getAttribute('data-cc-wishlist-remove') });
      return;
    }

    if (e.target.closest('[data-cc-wishlist-close]') || e.target.id === 'cc-wishlist-modal') {
      const modal = document.getElementById('cc-wishlist-modal');
      if (modal) modal.hidden = true;
    }
  });

  function observePdpWishlistContainer() {
    const container = document.getElementById('wishlist-hero-product-page-button');
    if (!container || container.__ccObserved) return;
    container.__ccObserved = true;
    new MutationObserver(() => {
      ensureSinglePdpWishlistButton();
    }).observe(container, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      syncWishlistUI();
      observePdpWishlistContainer();
      setTimeout(syncWishlistUI, 600);
      setTimeout(syncWishlistUI, 1800);
    });
  } else {
    syncWishlistUI();
    observePdpWishlistContainer();
    setTimeout(syncWishlistUI, 600);
    setTimeout(syncWishlistUI, 1800);
  }
})();

/* ---------- Sticky Add-to-Cart Live Total ---------- */
(function () {
  if (!document.querySelector('sticky-add-to-cart')) return;

  const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  const locale = 'en-US';
  const fmt = (cents) => {
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  };

  const currentVariant = () => {
    const scripts = document.querySelectorAll('variant-picker script[type="application/json"], swatches-variant-picker-component script[type="application/json"]');
    for (const s of scripts) {
      try {
        const v = JSON.parse(s.textContent);
        if (v && typeof v.price === 'number') return v;
      } catch (e) {}
    }
    return null;
  };

  const qtyInput = () =>
    document.querySelector('.product-details quantity-selector-component input, .product-details input[name="quantity"]');

  function render() {
    const bar = document.querySelector('.sticky-add-to-cart__price');
    if (!bar) return;
    const v = currentVariant();
    const input = qtyInput();
    const qty = Math.max(1, parseInt(input && input.value, 10) || 1);
    let el = document.querySelector('.cc-sticky-total');
    if (!el) {
      el = document.createElement('span');
      el.className = 'cc-sticky-total';
      el.setAttribute('aria-live', 'polite');
      bar.appendChild(el);
    }
    if (!v) {
      el.textContent = '';
      return;
    }
    const html = 'Total: <b>' + fmt(v.price * qty) + '</b>' + (qty > 1 ? ' (' + qty + ' × ' + fmt(v.price) + ')' : '');
    if (el.innerHTML !== html) el.innerHTML = html;
  }

  document.addEventListener('input', (e) => {
    if (e.target.closest('quantity-selector-component, .product-details')) render();
  });
  document.addEventListener('change', render);
  document.addEventListener('click', (e) => {
    if (e.target.closest('quantity-selector-component button, .quantity__button')) setTimeout(render, 30);
  });

  const root = document.querySelector('.product-information, product-information, main');
  if (root) {
    new MutationObserver((mutations) => {
      const external = mutations.some((m) => {
        const node = m.target.nodeType === 1 ? m.target : m.target.parentElement;
        return !(node && node.closest('.cc-sticky-total'));
      });
      if (!external) return;
      clearTimeout(window.__ccTotalT);
      window.__ccTotalT = setTimeout(render, 60);
    }).observe(root, { subtree: true, childList: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render);
  else render();
})();
